import React, { useMemo } from 'react';
import { MultiSelect } from 'primereact/multiselect';
import { useGetAllCountriesQuery } from '../../api/endpoints/country';
import { useLanguage } from '../../contexts/LanguageContext';

const CountryDropdownWithMultiSelect = ({ 
    value, 
    onChange, 
    className, 
    placeholder, 
    disabled = false,
}) => {
    const { getCurrentLanguageId, th } = useLanguage();

    const { data: countries = [], isLoading } = useGetAllCountriesQuery({ 
        languageId: getCurrentLanguageId() 
    });

    const countryOptions = useMemo(() => {
        return countries.map((country) => ({
            id: country.id || country.code || country.name,
            code: country.code,
            name: country.name,
            label: country.name,
            value: country.name
        }));
    }, [countries]);

    const selectedCountries = useMemo(() => {
        if (!value) return [];
        if (Array.isArray(value)) {
            if (value.every(v => typeof v === 'string')) {
                return value;
            }
            return value.map(v => v.name || v.value || v);
        }
        return [];
    }, [value]);

    const handleChange = (e) => {
        onChange(e.value || []);
    };

    

    return (
        <MultiSelect
            value={selectedCountries}
            onChange={handleChange}
            options={countryOptions}
            optionLabel="name"
            optionValue="name"
            className={className}
            placeholder={placeholder || th('customerAddress.countryPlaceholder')}
            disabled={disabled || isLoading}
            filter
            resetFilterOnHide
            showClear
            display="chip"
            selectedItemsLabel={`{0} ${th('common.selected')}`}
            emptyFilterMessage={th('filter.noResultsFound')}
            filterBy="name"
            virtualScrollerOptions={{ itemSize: 38 }}
            showSelectAll={false}  
        />
    );
};

export default CountryDropdownWithMultiSelect;